import { render, staticRenderFns } from "./kejianTj.vue?vue&type=template&id=e6b01ca6&scoped=true"
import script from "./kejianTj.vue?vue&type=script&lang=js"
export * from "./kejianTj.vue?vue&type=script&lang=js"
import style0 from "./kejianTj.vue?vue&type=style&index=0&id=e6b01ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b01ca6",
  null
  
)

export default component.exports